import { render, staticRenderFns } from "./BenefitsCard.vue?vue&type=template&id=f4597d1e&scoped=true&"
import script from "./BenefitsCard.vue?vue&type=script&lang=js&"
export * from "./BenefitsCard.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsCard.vue?vue&type=style&index=0&id=f4597d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4597d1e",
  null
  
)

export default component.exports